<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 20:21:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refunddetail/components/RefundStatus/index.vue
-->
<template>
  <!-- 售后详情详情头部状态信息 -->
  <div class="refund_status">
    <div class="text_left font_weight500 font14 colo087">
      {{ getAfterSaleInfo.statusDesc }}
    </div>
    <div class="text_left font_weight400 font12 colo087 status_det">
      {{ getAfterSaleInfo.tips }}
    </div>
    <div
      v-if="getAfterSaleInfo.accepter"
      class="text_left font_weight400 font12 colo087 status_add"
    >
      寄回地址：
    </div>
    <div
      v-if="getAfterSaleInfo.accepter"
      class="text_left font_weight400 font12 colo087"
    >
      {{ getAfterSaleInfo.accepter.name }}
      {{ getAfterSaleInfo.accepter.phone }}
      {{ getAfterSaleInfo.accepter.address }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getAfterSaleInfo() {
      return this.$store.getters.getAfterSaleInfo;
    }
  }
};
</script>

<style lang="less" scoped>
.refund_status {
  background: #fff;
  // margin: 0 12px;
  border-radius: 6px;
  padding: 12px;
  // position: absolute;
  // top: 78px;
  // width: 87.5%;
  .status_det {
    margin-top: 4px;
  }
  .status_add {
    margin-top: 10px;
  }
}
</style>
